
<template>
  <div class="success" v-if="code > 0">
      <div class="row" v-async="loading">
        <div class="col-xs-12">
          <div class="error-box text-center" v-if="!this.boletoUrl">
              <h1 class="bold">Oops!</h1>

              <p class="bold">Alguma coisa deu errada!</p>
              <p class="margin-20 line-height-20" v-if="cmpId===120">No momento um dos canais de finalização está indisponível. Tente novamente mais tarde ou entre em contato com a Central de Relacionamento.</p>
              <template v-else>
                <p class="margin-20 line-height-20" v-if="validacaoFraude && type == 'newVehicle' ">Não foi possível concluir sua compra. Por favor, entre em contato com nossa Central de Relacionamento, através dos números 4000 2901 (Capitais e regiões metropolitanas) e 0800 777 1022 (Demais localidades).</p>
                <p class="margin-20 line-height-20" v-else-if="!validacaoFraude &&  type == 'newVehicle'">Não foi possível confirmar o pagamento da sua adesão, por favor verifique os dados do seu cartão.</p>
                <p class="margin-20 line-height-20" v-if="validacaoFraude && type == 'newContract' ">Não foi possível concluir sua compra. Por favor, entre em contato com nossa Central de Relacionamento, através dos números 4000 2901 (Capitais e regiões metropolitanas) e 0800 777 1022 (Demais localidades).</p>
                <p class="margin-20 line-height-20" v-else-if="!validacaoFraude && type == 'newContract' ">Não foi possível concluir sua solicitação. Tente novamente ou entre em contato com a Central de Relacionamento.</p>
                <p class="margin-20 line-height-20" v-if="validacaoFraude && type == 'adhesion' ">Não foi possível concluir sua compra. Por favor, entre em contato com nossa Central de Relacionamento, através dos números 4000 2901 (Capitais e regiões metropolitanas) e 0800 777 1022 (Demais localidades).</p>
                <p class="margin-20 line-height-20" v-else-if="!validacaoFraude &&  type == 'adhesion'">Não foi possível concluir sua adesão. Tente novamente ou entre em contato com a Central de Relacionamento.</p>
                <p class="margin-20 line-height-20" v-if="type == 'replaceTag'">Não foi possível concluir a substituição do TAG. Tente novamente ou entre em contato com a Central de Relacionamento.</p>
                <p class="margin-20 line-height-20" v-if="validacaoFraude && type=='recharge'">Não foi possível concluir sua compra. Por favor, entre em contato com nossa Central de Relacionamento, através dos números 4000 2901 (Capitais e regiões metropolitanas) e 0800 777 1022 (Demais localidades).</p>
                <p class="margin-20 line-height-20" v-else-if="!validacaoFraude && type=='recharge'">Não foi possível concluir sua recarga. Tente novamente ou entre em contato com a Central de Relacionamento.</p>
                <p class="margin-20 line-height-20" v-if="validacaoFraude && type=='reprocess'">Não foi possível concluir sua compra. Por favor, entre em contato com nossa Central de Relacionamento, através dos números 4000 2901 (Capitais e regiões metropolitanas) e 0800 777 1022 (Demais localidades).</p>
                <p class="margin-20 line-height-20" v-else-if="!validacaoFraude && type=='reprocess'">Não foi possível reprocessar seu pedido. Tente novamente.</p>
              </template>
              <div class="text-center margin-30">
                <button v-if="type=='adhesion'" class="btn btn-purple" type="button" name="button" @click="doLogin()">
                  Reprocessar
                </button>
                <button v-else-if = "type=='reprocess'"  class="btn btn-purple" type="button" name="button" @click="paraPedidosReprocessamento()">
                  Reprocessar
                </button>
                <button v-else class="btn btn-purple" type="button" name="button" @click="paraPedidos()">
                  Reprocessar
                </button>
              </div>
            </div>
          <div class="error-box text-center" v-else>
            <h1 class="bold">Oops!</h1>
            <p class="margin-20 line-height-20" v-if="this.msgErrorResp">{{this.msgErrorResp}}</p>
            <p class="margin-20 line-height-20" v-else>Não foi possível gerar o boleto da sua compra. Por favor, entre em contato com nossa Central de Relacionamento, através dos números 4000 2901 (Capitais e regiões metropolitanas) e 0800 777 1022 (Demais localidades).</p>
            <button class="btn btn-purple" type="button" name="button" @click="paraPlanos()">
              Voltar
            </button>
          </div>

        </div>
      </div>
    </div>
</template>
<style lang="scss" scoped>
  @import "../../../styles/global/_colors.scss";
  @import "../../../styles/global/mixin/_mixins.scss";

  .success {
    @include border-radius(5px);
    border: 2px solid $gray;
    padding: 20px;
    background-color: #FAFAFA;
    .error-box {
      h1 {
        font-size: 73px;
        color: #C3C3C3;
        margin-bottom: 25px;
      }

      p {
        font-size: 16px;
        color: #353535;
      }
    }
  }

  @media screen and (max-width: 991px) {
    .success {
      .error-box {
        h1 {
          margin-top: 0;
        }

        p {
          font-size: 14px;
          line-height: 1.4;
        }

        .btn-purple {
          width: 220px;
          max-width: 270px;
          padding: 10px;
        }
      }
    }
  }

  @media screen and (min-width: 320px) and (max-width: 500px) {
    .success {
      .error-box {
        p {
          font-size: 13px;

          b {
            display: block;
          }

          &.margin-b30 {
            margin-bottom: 10px;
          }
        }
      }
    }
  }
</style>
<script>
  import auth from '../../../services/auth'
  import Financial from '../../../services/financial'


  export default {
    props:['code', 'stepPayment', 'type', 'taxIdNumber', 'password', 'salesOrder','validacaoFraude', 'boletoUrl', 'msgErrorResp', 'cmpId'],

    data(){
      return {
        loading: undefined,
        flag: 0,
        mensagem:undefined,
      }
    },
    methods:{
      getReprocessOrderId() {
        if (this.salesOrder && this.salesOrder.salesOrderId) {
          return this.salesOrder.salesOrderId;
        }
        if (this.salesOrder && this.salesOrder.orderId) {
          return this.salesOrder.orderId;
        }
        if (this.$route && this.$route.params && this.$route.params.orderId) {
          return this.$route.params.orderId;
        }
        return undefined;
      },
      paraPlanos() {
        this.$router.push({name: 'plans'});
      },
      paraPedidos() {
        const orderId = this.salesOrder && this.salesOrder.salesOrderId;
        if (orderId) {
          this.$router.push({name: 'reprocess-order', params: {orderId}});
        } else {
          this.$router.push({name: 'plans'});
        }
      },
      paraPedidosReprocessamento() {
        const salesOrderId = this.getReprocessOrderId();
        if (!salesOrderId) {
          this.$router.push({name: 'plans'});
          return;
        }

        this.loading = Financial.reprocessPayout({ salesOrderId: salesOrderId });
      },
      doLogin() {
          let username = this.taxIdNumber.replace(/[.\-\/]/g, '').toUpperCase();
          this.loading = auth.login(username, this.password)
            .then(user => {
              const orderId = this.salesOrder && this.salesOrder.salesOrderId;
              if (user.otherSalesReference === 'REPOM') {
                this.$router.push({
                  name: 'repom'
                });
              } else if (orderId) {
                this.$router.push({name: 'reprocess-order', params: {orderId}});
              } else {
                this.$router.push({name: 'plans'});
              }
            })
            .catch(err => {
              this.errorMessage = err.status && err.data.status && err.data.status.message || "Erro do servidor.";
            });
      }

  }
}
 </script>



// WEBPACK FOOTER //
// error.vue?9ba59830